import { Permission } from "domain/entities/permission"
import { Function } from "domain/entities/function";
import { MobileFunction, MobileRoute } from "../stores/navigation-store";
import { Role } from "domain/entities/role";

const TRIP_ROLES = ["Colaborador com Viagens de Suporte", "Colaborador com Viagens Livres"];
const TRIP_APPROVER_ROLES = ["Admin", "CEO", "Finanças"];

const mobileFunctions: MobileFunction[] = [
    {
        name: "vehicles"
    },
    {
        name: "vacations",
        showOnBar: true,
        requiredRoles: ["CTI"]
    },

    {
        name: "invoices",
        requiredRoles: ["CPS"]
    },
    {
        name: "timesheets",
        showOnBar: true
    },
    {
        name: "expenses"
    },
    {
        name: "tripsheets",
        routes: [
            {
                route: "trips",
                name: "trips",
                label: "Deslocações",
                icon: "pi pi-map",
                requiredRoles: [...TRIP_ROLES, ...TRIP_APPROVER_ROLES]
            },
            {
                route: "documents",
                name: "documents",
                label: "Documentos",
                icon: "pi pi-file",
                requiredRoles: ["CTI"]
            }

        ]
    },
    {
        name: "dashboards",
        routes: [
            {
                route: "approve-documents",
                name: "approve-documents",
                label: "Aprovar Documentos",
                icon: "pi pi-verified"
            },
            {
                route: "sign-documents",
                name: "sign-documents",
                label: "Assinar Documentos",
                icon: "pi pi-file-edit",
                requiredRoles: [
                    'Tripsheet Signer Secondary',
                    'Tripsheet Signer Main'
                ]

            }
        ]
    }
]


export function getMobileRoutes(functions: Function[] | undefined, permissions: Permission[] | undefined, roles: Role[] | undefined): MobileRoute[] {
    if (!functions) return [];
    const hasPermissionAccess = (functionId: string): boolean => {
        const permission = permissions?.find(
            (item) => item.functionId === functionId,
        );
        return permission ? true : false;
    };

    // Sem roles exigidos: acesso livre; caso contrário, o utilizador tem de ter pelo menos um deles
    const hasRequiredRole = (requiredRoles?: string[]): boolean => {
        if (!requiredRoles || requiredRoles.length === 0) return true;
        return roles?.some((role: Role) => requiredRoles.includes(role.name)) ?? false;
    };

    const functionsValidForMobile = functions.filter((fn) => {
        if (!hasPermissionAccess(fn.id ?? "")) return false;

        const mf = mobileFunctions.find(mf => mf.name === fn.name);
        if (!mf) return false;

        return hasRequiredRole(mf.requiredRoles);
    });

    const routes: MobileRoute[] = [{
        name: "home",
        label: "Home",
        route: "/mobile",
        icon: "pi pi-home",
        showOnBar: true
    }]

    functionsValidForMobile.forEach((fn) => {
        const mobileFunction = mobileFunctions.find(mf => mf.name === fn.name);
        const subRoutes: MobileRoute[] = [];
        if (mobileFunction?.routes && mobileFunction.routes.length > 0) {
            mobileFunction.routes.forEach((route) => {
                if (!hasRequiredRole(route.requiredRoles)) {
                    return;
                }
                subRoutes.push({
                    name: route.name,
                    route: `/mobile/${route.route}`,
                    label: route.label,
                    icon: `pi ${route.icon ?? fn.icon ?? "pi-question-circle"}`,
                    showOnBar: route.showOnBar ?? false,
                })
            })
            if (subRoutes.length === 0) return;
        }
        routes.push({
            name: fn.name ?? "",
            label: fn.label,
            route: `/mobile/${mobileFunction?.name ?? ""}`,
            icon: `pi ${fn.icon ?? ""}`,
            showOnBar: mobileFunction?.showOnBar ?? false,
            subRoutes: subRoutes
        })
    })

    return routes;
}
